export default __webpack_public_path__ + "static/logo-1528f05e91d2b1c0551a5581bf39a93d.svg";